module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Repositório "), (_vm.acs[_vm.acselecionada].nome != 'ACT SOLUTI') ? _c('span', [_vm._v("AC")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.acs[_vm.acselecionada].nome))]), _vm._v(" "), (_vm.acs[_vm.acselecionada].mensagem_intro) ? _c('div', {
    staticClass: "texto"
  }, [_c('p', [_vm._v(_vm._s(_vm.acs[_vm.acselecionada].mensagem_intro))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.acs[_vm.acselecionada].referencia) ? [(_vm.acs[_vm.acselecionada].referencia.imagem) ? [_c('img', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": _vm.acs[_vm.acselecionada].referencia.imagem
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br')] : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v(_vm._s(_vm.acs[_vm.acselecionada].referencia.titulo))]), _vm._v(" "), _vm._l((_vm.acs[_vm.acselecionada].referencia.links), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.nome))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(link.descricao)
      }
    })])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.acs[_vm.acselecionada].cadeias) ? _c('ccd-repositorio-cadeia', {
    attrs: {
      "nomeac": _vm.acs[_vm.acselecionada].nome,
      "cadeias": _vm.acs[_vm.acselecionada].cadeias
    }
  }) : _vm._e(), _vm._v(" "), (_vm.acs[_vm.acselecionada].documentos) ? _c('ccd-repositorio-docs', {
    attrs: {
      "nomeac": _vm.acs[_vm.acselecionada].nome,
      "docs": _vm.acs[_vm.acselecionada].documentos
    }
  }) : _vm._e(), _vm._v(" "), (_vm.acs[_vm.acselecionada].pss) ? _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("PSS - Prestadores de Serviço de Suporte")]), _vm._v(" "), _vm._l((_vm.acs[_vm.acselecionada].pss), function(pss) {
    return _c('li', [_c('a', {
      attrs: {
        "href": pss.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(pss.nome))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(pss.descricao))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.acs[_vm.acselecionada].nome != 'ACT SOLUTI') ? _c('div', [_c('ccd-repositorio-ar', {
    attrs: {
      "acselecionada": _vm.acselecionada
    }
  }), _vm._v(" "), _c('ccd-repositorio-acordo', {
    attrs: {
      "acselecionada": _vm.acselecionada
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-245286ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Repositorio.vue
// module id = 94
// module chunks = 0